import { AuthService } from "@js/services/AuthService";
import { DevelopmentInput, LenderResult } from "@src/apis/ModularClient";

export class EnquiryController {
  registeringAccount: boolean;
  registrationform: FormData;
  error: string;

  loanCriteria: DevelopmentInput;
  selectedResult: LenderResult;

  enquireAfterRegistration: boolean;

  //newUser: RegistrationRequestDTO = {
  //    Email: "", FirstName: "", LastName: ""
  //} as RegistrationRequestDTO;

  newUser: any = {};

  static $inject = [
    "$scope",
    "$rootScope",
    "$routeParams",
    "$cookies",
    "$location",
    "$http",
    "$httpParamSerializerJQLike",
    "AuthService",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $httpParamSerializerJQLike: ng.IHttpParamSerializer,
    private $auth: AuthService,
  ) {
    // rootScope.title = "Registration";
    if ($cookies.get("access_token")) {
      $location.path("dashboard");
    }

    this.loanCriteria = (this.$rootScope as any).loanCriteria;
    this.selectedResult = (this.$rootScope as any).selectedResult;

    if (this.$routeParams.enquire !== undefined) {
      this.enquireAfterRegistration = true;
    }
  }

  registerAccount() {
    this.registeringAccount = true;
    if (this.newUser.confirmPassword !== this.newUser.password) {
      this.error = "Passwords do not match";
    }
    // send registration
    this.$auth
      .registerAccount(this.newUser)
      .then((response) => {
        if (this.enquireAfterRegistration) {
          this.$location.path("/enquiry");
        } else {
          this.$location.path("/yourresults");
        }
      })
      .catch((response) => {
        this.error = "It looks like there was a problem registering. Please try again in a moment.";
      })
      .finally(() => {
        this.registeringAccount = false;
      });

    //if (this.selectedUser.id == null) {
    //    this.selectedUser.id = "";
    //    this.selectedUser.roles = [];
    //    this.selectedUser.roles.push("Client");
    //}
    //if (!this.selectedUser.userName) {
    //    this.selectedUser.userName = this.selectedUser.email; //set user name to be same as email address for now
    //}
    //this.loanCriteria.user = this.selectedUser;
    //this.loanCriteria.saveQueryAndResults = true;
    ////            this.$user.addUpdate(this.selectedUser).then((response) => {
    //this.$lenderresultservice.fetchMatchingResults(this.loanCriteria, false, false, 4).then((response) => {
    //    this.selectedUser.id = response.UserId;
    //    this.showsaveinfo = false;
    //});
  }

  clearRegistration() {
    this.registeringAccount = false;
  }
}
